<template>
	<div class="tangazo">
		<div class="title-content clearfix">
			<div class="title f-l">Sponsored Ads</div>
			<div class="controls clearfix f-r">
				<div class="previous f-l action" @click="previousAd()">
					<i class="fa fa-chevron-left"></i>
				</div>
				<div class="next f-l action" @click="nextAd()">
					<i class="fa fa-chevron-right"></i>
				</div>
			</div>
		</div>

		<div class="tangazo-box" v-if="ad">
			<AdImage
				v-if="ad.product_name"
				@click.native="productAdClicked({ router: $router, ad })"
				:product="ad"
			/>
			<AdRating v-else :product="ad" @click.native="adClickedEvent(ad)" />
		</div>
	</div>
</template>

<script>
import advert from '../../rsc/stores/advert.store';

export default {
	beforeCreate() {},
	beforeDestroy() {
		clearInterval(this.ad_interval);
		this.$store.unregisterModule('advert');
	},
	created() {
		utils.registerModule('advert', advert, this.$store);
	},
	components: {
		AdImage: () => import('./ad-image'),
		AdRating: () => import('./ad-rating'),
	},
	props: {},
	data() {
		return {};
	},
	computed: {
		...mapGetters(['back_ads', 'ad', 'ad_interval']),
	},
	methods: {
		...mapActions([
			'adClickedEvent',
			'previousAd',
			'nextAd',
			'getDisplayAd',
			'productAdClicked',
		]),
	},
	mounted() {
		utils.registerModule('advert', advert, this.$store);
		this.getDisplayAd();
	},
};
</script>

<style lang="less">
.tangazo {
	.title-content {
		.filter {
			font-weight: 600;
			cursor: pointer;

			.icon {
				font-size: 20px;
				margin: 1px 10px 0 0;
			}
		}
		.filter:hover {
			color: var(--ne-red) !important;
		}
	}
}
</style>
